var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoxedExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e63757",
  d: "M16 1.714v12.572c0 .947-.768 1.714-1.714 1.714H1.714A1.714 1.714 0 0 1 0 14.286V1.714C0 .768.768 0 1.714 0h12.572C15.233 0 16 .768 16 1.714m-1.714 12.357V1.93a.215.215 0 0 0-.215-.215H1.93a.214.214 0 0 0-.215.215V14.07a.214.214 0 0 0 .215.215H14.07a.215.215 0 0 0 .215-.215M9.5 11.43c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5c0-.828.673-1.5 1.5-1.5s1.5.672 1.5 1.5m-2.906-7.55.243 4.857c.011.228.2.407.428.407h1.47c.229 0 .417-.18.428-.407l.243-4.857a.43.43 0 0 0-.428-.45H7.022a.43.43 0 0 0-.428.45"
})));
export default SvgBoxedExclamation;